import { render, staticRenderFns } from "./DownlineRepBusinessAddressContent.vue?vue&type=template&id=79ffd146&"
import script from "./DownlineRepBusinessAddressContent.vue?vue&type=script&lang=js&"
export * from "./DownlineRepBusinessAddressContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports